module.exports = __webpack_public_path__ + "media/images/lab1-2ba543de.jpg";